import styled from 'styled-components';
import { th } from 'style/theme';
import { sizes } from 'style';
import { Text } from '../../styled';

export const BoxBg = styled.div`
  padding: 16px;
  border-radius: 8px;
  background-color: ${th('colors.fuzzyWuzzyBrown')};
  color: ${th('colors.white')};

  @media ${sizes.desktop} {
    border-radius: 16px;
  }
`;

export const Heading = styled(Text)`
  font-weight: 600;

  @media ${sizes.tabletLandscape} {
    margin-bottom: 8px;
  }
`;
